<div class="flex flex-row justify-between pb-3 pr-2 relative items-center">
    <div class="flex flex-row items-center">
        <!-- <h2 mat-dialog-title class="!pl-0 text-2xl !m-0 font-bold !text-blue-theme-color">{{this.heading}}</h2> -->
    </div>
    <button mat-icon-button class="dialog-close-btn flex items-center justify-center" mat-dialog-close>
        <mat-icon class="text-blue-theme-color text-xl">close</mat-icon>
    </button>
</div>
<mat-dialog-content class="!py-0">
    <div class="w-full py-4">
        <img class="w-72 mx-auto mb-9" src="assets/images/ui/noDriverAvailable.png" alt="">
        <!-- <div class="infoMessage text-lg" *ngIf="_data?.type == 'terms' ||_data?.type == 'policy'" [innerHtml]="this.infoMessage"></div> -->
        <p class="text-lg leading-5 text-center text-input-color font-medium">Currently, there are no drivers available for delivery in your area. Please check back later.</p>
    </div>
</mat-dialog-content>
<mat-dialog-actions class="!pb-5 !px-0 justify-center">
    <button color="primary" [mat-dialog-close]="true" class="!bg-blue-theme-color !w-full !h-11 text-white-color"
        mat-flat-button>Try Later</button>
</mat-dialog-actions>